import { UrlTree, CanDeactivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

export type CanDeactivateType = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

export interface CanComponentDeactivate {
  canDeactivate: () => CanDeactivateType;
  bypassCanDeactivate: boolean;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
  activatedRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot
) => {
  return !component.bypassCanDeactivate && component.canDeactivate ? component.canDeactivate() : true;
};
